import React from 'react'
import {Content} from '@builder.io/sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {customComponents} from 'hec/builder'
import {useFetchBuilderReference} from '../hooks/useFetchBuilderReference'

export interface ModelReference {
    id: string
    '@type': string
    model: string
    value?: {
        data: unknown
    }
}

export interface BuilderReferenceContentProps {
    reference?: ModelReference
    testId?: string
    model?: string
}
export const BuilderReferenceContent: React.FC<BuilderReferenceContentProps> = ({
    model = 'symbol',
    reference,
    testId = 'BuilderReferenceContent'
}) => {
    const config = getConfig()

    const {data, error, isLoading} = useFetchBuilderReference({
        model,
        shouldQuery: !!reference?.id && !reference?.value?.data,
        referenceId: reference?.id
    })

    if (reference?.value?.data !== undefined) {
        return (
            <Content
                model={model}
                content={reference}
                apiKey={config.app.builder.api}
                customComponents={customComponents}
                data-testid={testId}
                enrich={true}
            />
        )
    }

    if (!reference) {
        return null
    }

    if (isLoading) {
        return null
    }

    if (error) {
        console.error('Error fetching Builder reference:', error)
        return null
    }

    if (!data) {
        return null
    }

    return (
        <Content
            model={model}
            content={data}
            apiKey={config.app.builder.api}
            customComponents={customComponents}
            data-testid={testId}
            enrich={true}
        />
    )
}
